import auth from 'src/router/middleware/authentification/auth.js'
import cloudPathHandler from 'src/router/middleware/channels/cloud/cloudPathHandler.js'

const CloudWrapper = () => import('src/views/Channels/Cloud/CloudWrapper.vue')
const CloudFolderCreation = () => import('src/views/Channels/Cloud/Creation/CloudFolderCreation.vue')
const Cloud = () => import('src/views/Channels/Cloud/Cloud.vue')
const CloudFileCreation = () => import('src/views/Channels/Cloud/Creation/CloudFileCreation.vue')

export default [
  {
    path: '/cloud',
    component: Cloud,
    name: 'cloud-group-view',
    meta: {
      middleware: [auth],
      group: 'cloud',
      enableSwReload: true,
      headerText: 'global.headers.cloud'
    }
  },
  {
    path: '/cloud/lite',
    component: Cloud,
    name: 'cloud-group-view-lite',
    meta: {
      middleware: [auth],
      group: 'cloud',
      layout: 'sdui',
      headerText: 'global.headers.cloud',
      enableSwReload: true
    }
  },
  {
    path: '/cloud/upload/file/:channel_id?/:uuid?',
    component: CloudFileCreation,
    name: 'cloud-create-file',
    meta: {
      middleware: [auth],
      group: 'cloud',
      headerText: 'global.headers.cloud_upload_file'
    }
  },
  {
    path: '/cloud/create/file/:channel_id?/:uuid?',
    component: CloudFolderCreation,
    name: 'cloud-create-cloud-file',
    meta: {
      middleware: [auth],
      group: 'cloud',
      headerText: 'global.headers.cloud_create_file'
    }
  },
  {
    path: '/cloud/create/folder/:channel_id?/:uuid?',
    component: CloudFolderCreation,
    name: 'cloud-create-folder',
    meta: {
      middleware: [auth],
      group: 'cloud',
      headerText: 'global.headers.cloud_create_folder'
    }
  },
  {
    path: '/cloud/files/:channel_id/:uuid?',
    component: CloudWrapper,
    name: 'cloud-view',
    meta: {
      middleware: [auth, cloudPathHandler],
      group: 'cloud',
      headerText: 'global.headers.cloud'
    }
  }
]
